import { ArrowUpRight } from "lucide-react";
import { site } from "@/data/site";
import { Reveal } from "@/components/Reveal";
import { scrollToId } from "@/lib/lenis";

export default function Services() {
    return (
        <section id="services" data-testid="services-section" className="mx-auto max-w-[1600px] px-5 py-28 sm:px-10 sm:py-40">
            <Reveal>
                <p className="mb-4 font-mono text-[11px] uppercase tracking-[0.35em] text-[#E63946]">Leistungen</p>
                <h2 className="mb-16 font-display text-4xl font-bold uppercase leading-none tracking-tight text-[#F4F4F0] sm:text-6xl lg:text-7xl">
                    Was ich <span className="text-stroke">mache</span>
                </h2>
            </Reveal>

            <ul>
                {site.services.map((s, i) => (
                    <Reveal key={s.name} delay={0.03}>
                        <li>
                            <button
                                data-testid={`service-item-${i}`}
                                data-cursor="link"
                                onClick={() => scrollToId("contact")}
                                className="group flex w-full items-center justify-between gap-6 border-t border-white/10 py-7 text-left transition-colors duration-500 last:border-b hover:border-[#E63946]/60 sm:py-9"
                            >
                                <div className="flex items-baseline gap-5 sm:gap-10">
                                    <span className="font-mono text-xs text-[#A1A1AA] transition-colors duration-300 group-hover:text-[#E63946]">
                                        {String(i + 1).padStart(2, "0")}
                                    </span>
                                    <div>
                                        <span className="block font-display text-xl font-bold uppercase tracking-tight text-[#F4F4F0] transition-all duration-500 group-hover:translate-x-2 group-hover:text-[#E63946] sm:text-3xl lg:text-4xl">
                                            {s.name}
                                        </span>
                                        <span className="mt-1 block text-xs text-[#A1A1AA] opacity-0 transition-opacity duration-500 group-hover:opacity-100 sm:text-sm">
                                            {s.detail}
                                        </span>
                                    </div>
                                </div>
                                <ArrowUpRight
                                    size={26}
                                    className="shrink-0 text-[#A1A1AA] transition-all duration-500 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-[#E63946]"
                                />
                            </button>
                        </li>
                    </Reveal>
                ))}
            </ul>
        </section>
    );
}
